import { resolveBootstrapUserConfig } from '../userConfig/userConfigBootstrapCache';
import { applyUserConfigToDom } from '../userConfig/userConfigModel';

export function initializeTheme(): void {
  applyUserConfigToDom(resolveBootstrapUserConfig());
}
